<template>
    <div class="login">
        <h1>Reset Your Password</h1>
        <div>
            <form
                @submit.prevent="resetPassword"
                accept-charset="UTF-8"
                v-if="isInitial || isSaving || isFailed"
                novalidate="true"
            >
                <p class="error">{{ error }}</p>
                <div class="fields">
                    <label for="email">Email</label>
                    <input v-model="email" type="email" name="email" value />
                </div>
                <div>
                    <button type="submit" name="button">Reset Password</button>
                </div>
            </form>
        </div>
        <div v-if="isSuccess">
            <p>Check your email to reset your password.</p>
        </div>
        <div>
            <p>
                To ensure you receive your password reset email, be sure to add
                info@journeynorth.org to your address book or contacts. If you
                have any trouble, please contact us.
            </p>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3
let fd = new FormData()

export default {
    data() {
        return {
            email: '',
            error: null,
            currentStatus: STATUS_INITIAL
        }
    },
    created() {
        this.reset()
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL
            console.log(this.currentStatus)
            this.error = null
        },
        resetPassword() {
            this.error = null
            this.currentStatus = STATUS_SAVING

            if (!this.validEmail(this.email)) {
                this.error = 'Please enter a valid email address.'
                this.currentStatus = STATUS_FAILED
            }

            if (this.error) {
                return false
            }

            fd.append('email', this.email)

            return axios
                .post(process.env.VUE_APP_API_DOMAIN + '/password/reset', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(({ data }) => {
                    console.log(data)
                    this.error = null
                    this.currentStatus = STATUS_SUCCESS
                })
                .catch(err => {
                    // console.log(err);
                    this.error = err.response.data.message
                    this.currentStatus = STATUS_FAILED
                    // console.log(this.currentStatus)
                })
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(email)
        }
    }
}
</script>
